// extracted by mini-css-extract-plugin
export default {"table":"styles_table__lhWOG","dragging":"styles_dragging__yKRIX","headingRow":"styles_heading-row__eI2go","draggingOver":"styles_dragging-over__zt55N"};